module.exports = __webpack_public_path__ + "static/media/add event info.d530981a.svg";